import React from "react";
import { homepage } from "./data";
import { PAGE_6 } from "./assets";
import styles from './TextContainer.module.scss';
import { downloadApk,goHome } from "./Helper";
export default function TextContainer() {
 const onClickDownload=()=>{
    downloadApk();
 }
 const onClickGoHome=()=>{
     goHome();
 }
    return (
        <div className={styles["container"]}>
            <div className={styles["buttons"]}>
                <img src={PAGE_6.DOWNLOAD_BUTTON.default} alt="Download button" onClick={onClickDownload}/>
            </div>
            <div className={styles["buttons"]}>
                <a href={homepage}>
                    <img src={PAGE_6.HOME_BUTTON.default} alt="Home button" onClick={onClickGoHome} />
                </a>
            </div>
            <div className={styles["icon-container"]}>
                <img src={PAGE_6.ICON.default} alt="Icon" />
            </div>
        </div>
    )
}